<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title">{{ content.title }}</h1>
      </div>
      <FieldInput
        :value="inputValue"
        placeholder="First name"
        type="text"
        :onChange="(e) => (inputValue = e.currentTarget.value)"
        :validator="() => inputValidator"
      />
      <CustomButton
        variation="primary"
        :disabled="!inputValidator"
        :onClick="() => action(inputValue)"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import FieldInput from "@/components/FieldInput.vue";
import CustomButton from "@/components/CustomButton.vue";
export default {
  data() {
    return {
      inputValue: "",
    };
  },
  computed: {
    inputValidator() {
      if (this.inputValue !== "") {
        return true;
      }

      return false;
    },
  },
  components: { FieldInput, CustomButton },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        title: String,
        description: String,
        image: String,
      }),
    },
  },
};
</script>
